import { columns } from '@/domain/env/colums-base';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { CollectionBase } from '@/domain/types/collections';
import usePaginatedDocuments from '@/domain/use-cases/get-paginated-documents';
import Button from '@/presentation/components/button';
import LoadMoreButton from '@/presentation/components/load-more-button';
import Table from '@/presentation/components/table';
import { FiPlus } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';

const NewslettersPage = () => {
  const navigate = useNavigate();
  const { data, error, isLoading, isLoadingMore, hasMore, loadMore } =
    usePaginatedDocuments<CollectionBase>(DOCUMENTS_DB.NEWSLETTERS);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data.length && !isLoading) return <div>No hay datos</div>;

  const handleRowClick = (row: CollectionBase) => {
    navigate(`/dashboard/newsletters/details/${row.id}`);
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Publicaciones</h1>
        <Link to="/dashboard/newsletters/add">
          <Button label="Agregar publicación" icon={<FiPlus />} onClick={() => {}} />
        </Link>
      </div>
      <Table data={data} columns={columns} onRowClick={handleRowClick} />
      <LoadMoreButton hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={loadMore} />
    </div>
  );
};

export default NewslettersPage;
